<template lang="pug">
  delivery-complete(v-if="delivery" :delivery="delivery")
</template>

<script>
import DeliveryComplete from '../components/delivery/DeliveryComplete.vue'
export default {
  components: {
    DeliveryComplete
  },
  data () {
    return {
      delivery: null
    }
  },
  methods: {
    async fetchDelivery () {
      const response = await this.$store.dispatch('getDriverDeliveryById', { id: this.$route.params.deliveryId })
      if (response.status === 200) {
        this.delivery = response.data
      } else {
        this.$bvToast.toast('No se pudo obtener el envío', {
          title: 'Error',
          variant: 'danger'
        })
      }
    }
  },
  created () {
    this.fetchDelivery()
  }
}
</script>
